export function imageForServerLabel(label) {
  const imagesForServerLabels = {
    'four': '/images/four-64.png',
    'zero': '/images/zero-64.png',
    'three': '/images/three-64.png',
    'twoHall': '/images/two-hall-64.png',
    'twoCorner': '/images/two-corner-64.png',
    'one': '/images/one-64.png',
    'exit': '/images/exit.png',
    'playerStart': '/images/star.png',
    'key': '/images/key.png',
    'spotter': 'images/spotter.png'
  };
  return imagesForServerLabels[label];
}

export function imageForLabel(label) {
  const imagesForLabels = {
    'fourTile': '/images/four-64.png',
    'zeroTile': '/images/zero-64.png',
    'threeUpTile': '/images/three-64.png',
    'threeRightTile': '/images/three-64.png',
    'threeDownTile': '/images/three-64.png',
    'threeLeftTile': '/images/three-64.png',
    'twoHallVerticalTile': '/images/two-hall-64.png',
    'twoHallHorizontalTile': '/images/two-hall-64.png',
    'twoCornerUpTile': '/images/two-corner-64.png',
    'twoCornerRightTile': '/images/two-corner-64.png',
    'twoCornerDownTile': '/images/two-corner-64.png',
    'twoCornerLeftTile': '/images/two-corner-64.png',
    'oneUpTile': '/images/one-64.png',
    'oneRightTile': '/images/one-64.png',
    'oneDownTile': '/images/one-64.png',
    'oneLeftTile': '/images/one-64.png',
    'exitTile': '/images/exit.png',
    'playerStart': '/images/star.png',
    'key': '/images/key.png',
    'removeEnemy': '/images/remove-enemy.png',
    'spotter': 'images/spotter.png'
  };
  return imagesForLabels[label];
}

export function orientationForLabel(label) {
  const orientationsForLabels = {
    'fourTile': 'UP',
    'zeroTile': 'UP',
    'threeUpTile': 'UP',
    'threeRightTile': 'RIGHT',
    'threeDownTile': 'DOWN',
    'threeLeftTile': 'LEFT',
    'twoHallVerticalTile': 'UP',
    'twoHallHorizontalTile': 'RIGHT',
    'twoCornerUpTile': 'UP',
    'twoCornerRightTile': 'RIGHT',
    'twoCornerDownTile': 'DOWN',
    'twoCornerLeftTile': 'LEFT',
    'oneUpTile': 'UP',
    'oneRightTile': 'RIGHT',
    'oneDownTile': 'DOWN',
    'oneLeftTile': 'LEFT',
    'exitTile': 'RIGHT'
  };
  return orientationsForLabels[label];
}

// Used for the selector to know which "selected" tile to display
export function tileTypeForLabel(label) {
  const tileTypesForLabels = {
    'fourTile': 'four',
    'zeroTile': 'zero',
    'threeUpTile': 'three',
    'threeRightTile': 'three',
    'threeDownTile': 'three',
    'threeLeftTile': 'three',
    'twoHallVerticalTile': 'twoHall',
    'twoHallHorizontalTile': 'twoHall',
    'twoCornerUpTile': 'twoCorner',
    'twoCornerRightTile': 'twoCorner',
    'twoCornerDownTile': 'twoCorner',
    'twoCornerLeftTile': 'twoCorner',
    'oneUpTile': 'one',
    'oneRightTile': 'one',
    'oneDownTile': 'one',
    'oneLeftTile': 'one',
    'exitTile': 'exit',
    'playerStart': 'playerStart',
    'key': 'key',
    'removeEnemy': 'removeEnemy',
    'spotter': 'spotter'
  };
  return tileTypesForLabels[label];
}
